import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Box } from '../Box/Box.js';
import { Divider as DividerMemoized } from '../Divider/Divider.js';
import { FocusTrap } from '../FocusTrap/FocusTrap.js';
import { CloseButton } from '../Modal/CloseButton.js';
import { Overlay } from '../Modal/Overlay.js';
import { Portal } from '../Portal/Portal.js';
import { BottomSheetHeader } from './BottomSheetHeader/BottomSheetHeader.js';
import { useBottomSheet } from './useBottomSheet.js';

var _excluded = ["children"];
var ContainerBox = Box;
var ContentBox = Box;
var ContentWrapperBox = Box;
var BottomSheet = function BottomSheet(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useBottomSheet = useBottomSheet(rest),
    containerBoxProps = _useBottomSheet.containerBoxProps,
    headerElement = _useBottomSheet.headerElement,
    closeButton = _useBottomSheet.closeButton,
    divider = _useBottomSheet.divider,
    contentHeading = _useBottomSheet.contentHeading,
    bottomSheetHeaderProps = _useBottomSheet.bottomSheetHeaderProps,
    focusTrapProps = _useBottomSheet.focusTrapProps,
    overlayProps = _useBottomSheet.overlayProps,
    shouldRenderOverlay = _useBottomSheet.shouldRenderOverlay,
    shouldRenderBottomSheet = _useBottomSheet.shouldRenderBottomSheet,
    contentBoxProps = _useBottomSheet.contentBoxProps,
    contentWrapperBoxProps = _useBottomSheet.contentWrapperBoxProps,
    rootContainer = _useBottomSheet.rootContainer;
  if (!shouldRenderBottomSheet && !shouldRenderOverlay) return null;
  var bottomSheetComponent = /*#__PURE__*/React.createElement(Overlay, overlayProps, /*#__PURE__*/React.createElement(FocusTrap, focusTrapProps, /*#__PURE__*/React.createElement(ContainerBox, containerBoxProps, headerElement || /*#__PURE__*/React.createElement(BottomSheetHeader, bottomSheetHeaderProps), closeButton && /*#__PURE__*/React.createElement(CloseButton, closeButton), divider && /*#__PURE__*/React.createElement(DividerMemoized, null), /*#__PURE__*/React.createElement(ContentWrapperBox, contentWrapperBoxProps, contentHeading, /*#__PURE__*/React.createElement(ContentBox, contentBoxProps, children)))));
  return rootContainer ? /*#__PURE__*/React.createElement(Portal, {
    container: rootContainer
  }, bottomSheetComponent) : bottomSheetComponent;
};
var BottomSheetMemoized = /*#__PURE__*/React.memo(BottomSheet);
BottomSheetMemoized.displayName = 'BottomSheet';

export { BottomSheet as BaseBottomSheet, BottomSheetMemoized as BottomSheet };
//# sourceMappingURL=BottomSheet.js.map
